window.M = window.M || {};
window.M.Api = window.M.Api || {};
window.M.Api.Site = {
	getOffboardingStatus: function(siteid, onComplete) {
		return M.Api.get("/api/site/" + siteid + "/offboard", onComplete);
	},
	confirmOffboarding: function(siteid, onComplete) {
		return M.Api.post("/api/site/" + siteid + "/offboard/confirm", null, onComplete);
	},
	deleteAspect: function(siteid, aspect, onComplete) {
		return M.Api.makeCall("DELETE", "/api/site/" + siteid + "/offboard/" + aspect, null, onComplete);
	},
	checkPermissions: function(siteid, onComplete) {
		return M.Api.get("/api/site/" + siteid + "/permissions/check", onComplete);
	},
	syncPermissions: function(siteid, onComplete) {
		return M.Api.post("/api/site/" + siteid + "/permissions/sync", null, onComplete);
	},
};